// Privacy.jsx
import React from "react";
import css from "./Privacy.module.css";

export default function Privacy() {
  return (
    <section className={css.container}>
      <div className={css.content}>
        <h1 className={css.title}>Política de Privacidade</h1>

        <p className={css.update}>Última atualização: 2025</p>

        <h2>1. Introdução</h2>
        <p>
          Esta Política de Privacidade descreve como a plataforma
          <strong> ProcessBasedPersonality</strong> trata os dados pessoais de
          usuários que participam de grupos de discussão, cursos, eventos
          educacionais e demais conteúdos disponibilizados no site.
        </p>

        <p>
          A plataforma possui caráter exclusivamente educacional e comunitário,
          voltado à formação continuada de profissionais da saúde mental, não
          oferecendo psicoterapia, supervisão clínica formal ou atendimento em
          saúde.
        </p>

        <h2>2. Dados que coletamos</h2>
        <p>
          Coletamos apenas os dados estritamente necessários para o
          funcionamento seguro e adequado da plataforma.
        </p>

        <h3>2.1 Dados de cadastro</h3>
        <p>
          Nome, e-mail, foto de perfil (quando utilizada autenticação via
          provedores externos) e identificador interno do Firebase (UID).
        </p>

        <h3>2.2 Dados de navegação</h3>
        <p>
          Informações técnicas como endereço IP, tipo de dispositivo, navegador,
          registros de acesso (logs), cookies essenciais e, quando autorizado
          pelo usuário, dados de analytics.
        </p>

        <h3>2.3 Dados educacionais</h3>
        <p>
          Informações relacionadas à participação em grupos de discussão,
          inscrição em cursos, presença em eventos, progresso em conteúdos e
          interações realizadas na plataforma.
        </p>

        <h3>2.4 Dados sensíveis</h3>
        <p>
          A plataforma <strong>não coleta, armazena ou processa</strong> dados
          clínicos, prontuários, registros terapêuticos, gravações de sessões ou
          informações sensíveis de pacientes.
        </p>

        <h2>3. Finalidades do tratamento</h2>
        <p>Os dados pessoais são tratados para as seguintes finalidades:</p>
        <ul>
          <li>Criação e gerenciamento de contas de usuário</li>
          <li>Organização de cursos, grupos de discussão e eventos</li>
          <li>Comunicação com os usuários</li>
          <li>Melhoria contínua da experiência educacional</li>
          <li>Cumprimento de obrigações legais e regulatórias</li>
        </ul>

        <h2>4. Cookies</h2>
        <p>
          Utilizamos cookies essenciais para o funcionamento da plataforma.
          Cookies de análise de desempenho e uso (analytics) são utilizados
          apenas mediante consentimento do usuário, quando aplicável.
        </p>

        <h2>5. Compartilhamento de dados</h2>
        <p>
          Os dados podem ser compartilhados com fornecedores estritamente
          necessários para o funcionamento da plataforma, tais como:
        </p>
        <ul>
          <li>Firebase / Google Cloud (infraestrutura e autenticação)</li>
          <li>Google Meet (realização de encontros ao vivo)</li>
          <li>Provedores de pagamento, quando houver cursos pagos</li>
        </ul>

        <h2>6. Direitos do usuário</h2>
        <p>
          Nos termos da Lei Geral de Proteção de Dados (LGPD), o usuário pode, a
          qualquer momento:
        </p>
        <ul>
          <li>Acessar seus dados pessoais</li>
          <li>Solicitar correção ou atualização</li>
          <li>Solicitar exclusão da conta e dos dados</li>
          <li>Revogar consentimentos concedidos</li>
        </ul>

        <h2>7. Retenção dos dados</h2>
        <p>
          Os dados pessoais são armazenados enquanto a conta do usuário estiver
          ativa ou pelo tempo necessário para cumprimento de obrigações legais.
        </p>

        <h2>8. Transferência internacional</h2>
        <p>
          Os dados podem ser processados em servidores localizados fora do
          Brasil, especialmente na infraestrutura do Google Cloud, observadas as
          garantias previstas na legislação aplicável.
        </p>

        <h2>9. Alterações desta Política</h2>
        <p>
          Esta Política de Privacidade pode ser atualizada periodicamente.
          Recomendamos que o usuário revise este documento regularmente.
        </p>

        <h2>10. Contato</h2>
        <p>
          Plataforma ProcessBasedPersonality
          <br />
          Responsável legal: Instituto Bhava LTDA — CNPJ 63.304.502/0001-26
          <br />
          E-mail de contato: <strong>institutobhava@gmail.com</strong>
        </p>
      </div>
    </section>
  );
}
